/**
 * Guide bodies, loaded on demand: each is its own chunk, fetched when its
 * guide opens. The pre-renderer preloads them all (renderPage.jsx), so the
 * static page carries the full article.
 */
import { GUIDE_BODY_LOADERS } from './loaders.js';

const loaded = new Map();

/** Make bodies available synchronously ({ slug: body }); the pre-renderer calls this. */
export function preloadGuideBodies(bodies) {
  for (const [slug, body] of Object.entries(bodies)) loaded.set(slug, body);
}

/** The body if it's already here, else null. */
export const loadedGuideBody = (slug) => loaded.get(slug) || null;

/** The body, fetching its chunk the first time. Null for an unknown slug. */
export async function loadGuideBody(slug) {
  if (loaded.has(slug)) return loaded.get(slug);
  const load = GUIDE_BODY_LOADERS[slug];
  if (!load) return null;
  const body = (await load()).default;
  loaded.set(slug, body);
  return body;
}
